<ui-section
	[collapsable]="true"
	[collapsed]="shouldCollapseSignal()"
	[title]="sectionTitle"
	(onCollapsedChange)="onCollapsedChange($event)"
	[titleImg]="titleImgConfigSignal()"
	[testHook]="testHooks.TitleSection"
>
	<div section-content class="grid grid-cols-2 gap-12">
		<div class="flex flex-col gap-6 h-fit">
			<div class="flex flex-col gap-4">
				<h4 class="text-lg font-medium text-gray-950 m-0">Provider</h4>
				<app-select
					[required]="true"
					label="Set Default Provider"
					[ngModel]="defaultProviderSignal()"
					(ngModelChange)="setDefaultProvider($event)"
					[testHook]="testHooks.SetDefaultProviderSelect"
				>
					@for (option of idvProviders; track option.value) {
						<option
							[value]="option.value"
							[testHook]="testHooks.IdvProviderOption"
						>
							{{ option.label }}
						</option>
					}
				</app-select>
			</div>

			<app-idv-finances-general
				*ngIf="isTreefortConnected"
			></app-idv-finances-general>
		</div>

		<app-idv-treefort-verification-general
			*ngIf="isTreefortConnected"
		></app-idv-treefort-verification-general>
	</div>
</ui-section>
